import React from 'react'
import { useParams } from 'react-router-dom'
import { useGetAdminWebinarDetailsQuery } from '../webinarApiSlice'
import WebinarDetails from '../../../container/webinarContainer/webinarDetails'
import Heading from '../../../components/header'

const ViewWebinarDetailPage = () => {

    const { id } = useParams()

    const { data, isLoading, isError } = useGetAdminWebinarDetailsQuery(id)
    return (
        <>

            <Heading
                text={`Webinar Details`}
                // btn_name="ADD PAPERS"
                path="#"
                // search={props.question.filters.search}
                // onSearch={onSearch}
                // search={search}
                isFilterShow={false}
                isGraphShow={false}
            />
            <WebinarDetails data={data} />
        </>
    )
}

export default ViewWebinarDetailPage
